import { render } from "./collection-pagination.vue?vue&type=template&id=032a14f7"
import script from "./collection-pagination.vue?vue&type=script&lang=js"
export * from "./collection-pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__